import router from "@/global-config/router/routes-registration/route";

export const REFERRAL_CODE_KEY = 'referralCode';

// Extracts a referral code from a link like https://host?ref=CODE
function extractReferralCode(to) {
    if (to.query && typeof to.query.ref === 'string' && to.query.ref.trim() !== '') {
        return to.query.ref.trim();
    }
    return null;
}

router.beforeEach((to, from, next) => {

    if(to.path.indexOf('app') > -1){
        document.body.classList.remove("blank-page")
    }else{
        document.body.classList.add("blank-page")
    }

    // Persist referral code so it survives the auth redirects (/ -> /app -> /auth/verify -> ... -> /auth/signup).
    // sessionStorage is used on purpose: localStorage is cleared on 401 / logout.
    const referralCode = extractReferralCode(to);
    if (referralCode) {
        sessionStorage.setItem(REFERRAL_CODE_KEY, referralCode);
    }

    if (to.path == '/' || to.path == '/app/') {
        next({ path: '/app', query: to.query });
    } else {
        next();
    }

    // Remove ST query parameter if present in /app route
    if (to.path == '/app' && to.query.ST) {
        const newQuery = { ...to.query };
        delete newQuery.ST;

        next(false);  // Abort current navigation
        router.replace({ path: to.path, query: newQuery });
        return;
    }

})
